import { combineReducers } from "redux";
import infrastructureReducer from "./infrastructureReducer";
import appReducer from "./appReducer";
import authReducer from "./authReducer";
import usersReducer from './usersReducer';
import alarmsReducer from './alarmsReducer';

const rootReducer = combineReducers({
    infrastructures: infrastructureReducer,
    app: appReducer,
    users: usersReducer,
    alarms: alarmsReducer,
    auth: authReducer,
});

export default rootReducer;